import { useState, useEffect } from "react";
import {
  collection,
  query,
  where,
  onSnapshot,
  orderBy,
} from "firebase/firestore";
import { db } from "../utils/firebase/firebase";
import { currentTimeAndDate } from "../utils/variables";
// import { useSelector } from "react-redux";

const useAnalysesOnSnapshot = (documentId) => {
  const [isLoading, setIsLoading] = useState(true);
  const [isError, setIsError] = useState(false);
  const [analyses, setAnalyses] = useState([]);
  // const analysisAndGraphs = useSelector(
  //   (state) => state.dataTable.analysisAndGraphs
  // );

  useEffect(() => {
    const collectionRef = query(
      collection(db, `Documents/${documentId}/Analysis`),
      where("isArchived", "==", false),
      orderBy("dateTime", "desc")
    );

    const unsub = onSnapshot(collectionRef, (querySnapshot) => {
      let tempTestsArr = [];
      // console.log(querySnapshot.size);
      querySnapshot.forEach((doc) => {
        const docData = doc.data();
        const dateTime = currentTimeAndDate(docData.dateTime.toDate());

        tempTestsArr.push({
          id: doc.id,
          ...doc.data(),
          dateTime,
        });
      });
      // console.log(tempTestsArr);
      setIsLoading(false);
      setAnalyses(tempTestsArr);
    });

    return () => {
      unsub();
    };
  }, [documentId]);

  return { isLoading, isError, analyses };
};

export default useAnalysesOnSnapshot;
